/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespFollowSearchBanner_viewer$ref: FragmentReference;
export type SbRespFollowSearchBanner_viewer = {|
  +isSbRespFollowSearchEnabled: ?boolean,
  +$refType: SbRespFollowSearchBanner_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespFollowSearchBanner_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSbRespFollowSearchEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd384253c2ed062f31928e66e18bd8e1a';
module.exports = node;
